import React, { useEffect } from 'react';
import { useLoaderData, useOutletContext } from 'react-router-dom';

import Flights from '../../components/Flights';

import { getDashboard } from 'api/dashboards';

const dashboardQuery = (id) => ({
    queryKey: ['dashboards', id],
    queryFn: async () => getDashboard(id),
});

export const loader =
    (queryClient) =>
    async ({ params }) => {
        const query = dashboardQuery(params.dashboardId);
        return queryClient.getQueryData(query) ?? (await queryClient.fetchQuery(query));
    };

export default function ShowDashboard() {
    const dashboard = useLoaderData();
    const { setDashboardName, setDashboardLastUpdatedAt, setDashboardId, filterAlertedFlights } = useOutletContext();

    useEffect(() => {
        setDashboardName(dashboard.name);
        setDashboardId(dashboard.id);
    }, [dashboard]);

    return (
        <div data-testid="route-dashboards-show">
            <Flights
                dashboard={dashboard}
                setDashboardLastUpdatedAt={setDashboardLastUpdatedAt}
                filterAlertedFlights={filterAlertedFlights}
            />
        </div>
    );
}
